import { Module } from 'vuex'

import { ChainStoreState, RootState } from '@/types/store'

import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'

const state: ChainStoreState = {
  chainStores: [],
}

export const chainStore: Module<ChainStoreState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
